/* index.tsx generated by @compiled/babel-plugin v3.0.2 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4c065U8HPE%7Bpadding-block%3Avar(--ds-space-150%2C9pt)%7D%0A._0aNu0LYbGa%7Blist-style-type%3Anone%7D%0A._43nrzTPgdg%7Bmargin-block-start%3Avar(--ds-space-0%2C0)%7D");


import { Box } from '@atlaskit/primitives/compiled/box';
import { Inline } from '@atlaskit/primitives/compiled/inline';
import { Stack } from '@atlaskit/primitives/compiled/stack';
import Skeleton from '@atlaskit/skeleton';
const styles = {
  outerContainer: "_4c065U8HPE _0aNu0LYbGa _43nrzTPgdg"
};
type Props = {
  asListItem?: boolean;
};
export const ListItemSkeleton = ({
  asListItem = false
}: Props): React.ReactNode => <Box xcss={styles.outerContainer} as={asListItem ? 'li' : undefined}>
		<Inline spread="space-between" alignBlock="center" space="space.200">
			<Skeleton width="32px" height="32px" />
			<Stack space="space.050" grow="fill">
				<Skeleton height={16} width="100%" />
				<Skeleton height={16} width="100%" />
			</Stack>
		</Inline>
	</Box>;